import './smt.scss';

import '@/utils/common.js';
import ScrollAnim from '@/utils/scroll-anim.js';
import initLeaderIntroduction from '@/components/leader-introduction/leader-introduction.js';

new ScrollAnim();
initLeaderIntroduction();

$(function () {
    if ($(window).outerWidth() < 768) {
    } else {
        $(document).scroll(function () {
            if (
                $(this).scrollTop() >
                $('.part-2').offset().top + $('.part-2').outerHeight()
            ) {
                $('.part-2').css({
                    backgroundPosition: '0 0',
                });
            } else if (
                $(this).scrollTop() <
                $('.part-2').offset().top - $(window).outerHeight()
            ) {
                $('.part-2').css({
                    backgroundPosition: '0 100%',
                });
            } else {
                const p =
                    (($('.part-2').offset().top +
                        $('.part-2').outerHeight() -
                        $(this).scrollTop()) /
                        ($(window).outerHeight() +
                            $('.part-2').outerHeight())) *
                    100;
                $('.part-2').css({
                    backgroundPosition: `0 ${p}%`,
                });
            }
        });

        let $timeline = $('.time-line').data({ animStatus: false });
        function handlePageScroll() {
            if (
                $(document).scrollTop() >=
                    $timeline.offset().top +
                        $timeline.outerHeight() / 2 -
                        $(window).outerHeight() &&
                !$timeline.data('animStatus')
            ) {
                $timeline.data({ animStatus: true }).addClass('into-page');
            }
        }
        handlePageScroll();
        $(document).scroll(handlePageScroll);
    }
});
